jQuery(function ($) {
    const map = L.map('map_leaflet').setView([37.095212, -3.398863], 17);
    const marker = L.marker([37.095212, -3.398863]).addTo(map);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
});